<div #splashScreen
     class="kt-splash-screen text-center">
    <img [attr.src]="'./assets/media/loader/Q-Loader.gif'"
         alt="Logo">
</div>